import { EmploymentType, WorkMode, JobOfferStatus } from '@/types';

/**
 * Format employment type enum to human-readable text
 */
export const formatEmploymentType = (type?: EmploymentType): string => {
  if (!type) return '';

  const mapping: Record<EmploymentType, string> = {
    FULL_TIME: 'Full Time',
    PART_TIME: 'Part Time',
    CONTRACT: 'Contract',
    INTERNSHIP: 'Internship',
  };

  return mapping[type] || type;
};

/**
 * Format work mode enum to human-readable text
 */
export const formatWorkMode = (mode?: WorkMode): string => {
  if (!mode) return '';

  const mapping: Record<WorkMode, string> = {
    REMOTE: 'Remote',
    HYBRID: 'Hybrid',
    ONSITE: 'Onsite',
  };

  return mapping[mode] || mode;
};

/**
 * Format employment type and work mode together
 */
export const formatEmploymentInfo = (type?: EmploymentType, mode?: WorkMode): string => {
  const parts = [formatEmploymentType(type), formatWorkMode(mode)].filter(Boolean);
  return parts.join(' • ');
};

/**
 * Format salary range to human-readable text
 */
export const formatSalary = (
  min?: number,
  max?: number,
  currency: string = 'TND'
): string | null => {
  if (!min && !max) return null;
  if (min && max) {
    return `${min.toLocaleString()} - ${max.toLocaleString()} ${currency}`;
  }
  if (min) return `${min.toLocaleString()}+ ${currency}`;
  if (max) return `Up to ${max.toLocaleString()} ${currency}`;
  return null;
};

/**
 * Get status color classes for job offer status badges
 */
export const getJobOfferStatusColor = (status: JobOfferStatus): string => {
  switch (status) {
    case 'PENDING':
      return 'text-yellow-600 bg-yellow-50 border-yellow-200';
    case 'VIEWED':
      return 'text-blue-600 bg-blue-50 border-blue-200';
    case 'ACCEPTED':
      return 'text-green-600 bg-green-50 border-green-200';
    case 'REJECTED':
      return 'text-red-600 bg-red-50 border-red-200';
    case 'WITHDRAWN':
    case 'EXPIRED':
      return 'text-gray-600 bg-gray-50 border-gray-200';
    default:
      return 'text-gray-600 bg-gray-50 border-gray-200';
  }
};
